
export const baseApiUrl = 'https://apaixonadossaudepet.intelite.com.br/api/'
//export const baseApiUrl = 'http://localhost:3002/api/'
export const userKey = '__orale_user'
export const modelBoleto = {
    pagadorDocumentoTipo: 1,
    pagadorDocumentoNumero: '',
    pagadorNome: '',
    pagadorEndereco: '',
    pagadorBairro: '',
    pagadorCidade: '',
    pagadorUf: '',
    pagadorCep: '',
    dataVencimento: '',
    valorNominal: 0,
    multaPercentual: 0,
    multaQuantidadeDias: 0,
    jurosPercentual: 0,
    tipoDesconto: 0,
    descontoValor: 0,
    descontoDataLimite: '',
    valorAbatimento: 0,
    tipoProtesto: 0,
    protestoQuantidadeDias: 0,
    baixaQuantidadeDias: 0,
    mensagem: '',
    tipoTitulo: 4,
    nsu: '',
    nossoNumero: 0,
    seuNumero: '',
    convenioId: '5056851c-af56-4d12-9338-47a6314984e9'
}

export default { baseApiUrl, modelBoleto }